'use client';
import TagsAndShare from "../../TagsAndShare";

export default function SolutionTagsAndShare(props) {
  return <TagsAndShare showEmptyTags={false} {...props} />;
}
